import { createRouter, createWebHistory } from 'vue-router';
import Home from './components/HomePage.vue';
import Collection from './components/CollectionPage.vue';
import About from './components/AboutPage.vue';
import Product from './components/ProductPage.vue';
import NotFound from './components/NotfoundPage.vue';

// Define your routes
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/collection',
    name: 'collection',
    component: Collection
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/products/:id',
    name: 'product',
    component: Product
  },
  {
    path: '/collection/:filter',
    name: 'collection-filter',
    component: Collection
  },
  {
    path: '/404',
    name: 'notfound',
    component: NotFound
  },
  // Updated catch-all route for 404 handling
  {
    path: '/:pathMatch(.*)*', // Catch-all route
    name: 'catch-all',
    redirect: '/404'
  }
];

// Create the router instance
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Export the router
export default router;